import { q, forEachIfArray } from './utilities';
import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import yall from 'yall-js';
require('./init-vue');

const firstPlusEl = q('.earning-calculator .sec_1 .plus-1');
if (Array.isArray(firstPlusEl)) {
  firstPlusEl.forEach(el => el.classList.add('hide'))
} else {
  firstPlusEl.classList.add('hide');
}

function updateStickyNav() {
  const headerEl = q('.global-header');
  const pageNavEl = q('#page-nav');
  const heroEl = q('.hero');
  const pageNav_h = pageNavEl.offsetHeight;
  const header_h = headerEl.offsetHeight;

  if (window.scrollY >= heroEl.offsetHeight) {
    headerEl.style.position = 'absolute';
    headerEl.style.top = heroEl.offsetHeight + 'px';
    headerEl.classList.add('no-shadow');
  } else {
    headerEl.style.position = 'fixed';
    headerEl.style.top = 0;
    headerEl.classList.remove('no-shadow');
  }

  if (window.scrollY >= heroEl.offsetHeight + header_h) {
    pageNavEl.classList.add('sticky');
    heroEl.style.marginBottom = `${pageNav_h}px`;
  } else {
    pageNavEl.classList.remove('sticky');
    heroEl.style.marginBottom = 0;
  }
}

new Swiper('.moments .swiper', {
  modules: [Pagination],
  loop: true,
  spaceBetween: 20,
  slidesPerView: 1,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

const imgs = document.images;
const len = imgs.length;
let counter = 0;

[].forEach.call(imgs, (img) => {
  if (img.complete) {
    incrementCounter();
  } else {
    img.addEventListener('load', incrementCounter, false);
  }
});

function incrementCounter() {
  counter++;
  if (counter === len) {
    q('.lazy').map(el => {
      el.src = el.dataset.src;
      el.classList.remove('lazy');
    });
  }
}

window.addEventListener('pageshow', () => {
  forEachIfArray(q('.earning-calculator input'), (el) => {
    el.value = 0;
  });
  forEachIfArray(q('.earning-calculator .points-value'), (el) => {
    el.textContent = 0;
  });
  forEachIfArray(q('.earning-calculator .total-points'), (el) => {
    el.textContent = 0;
  });
});

document.addEventListener('DOMContentLoaded', () => {
  yall({
    observeChanges: true,
  });
});

document.addEventListener('scroll', () => {
  updateStickyNav();
});

window.addEventListener('resize', () => {
  updateStickyNav();
});
